import React, {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import BeneficiaryForm from './BeneficiaryForm';
import SimpleList from './SimpleList';
import SimpleExpansionPanel from './SimpleExpansionPanel';
import BeneficiaryFindAccount from './BeneficiaryFindAccount';
import { Button, Grid, AppBar, Toolbar, IconButton, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
// import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { checkPermissionUser } from '../../functions/permissions-functions';


const useStyles = makeStyles(theme => ({
    textField: {
        width: 200,
    },
    margin: {
        margin: theme.spacing(1),
    },
    logo: {
        [theme.breakpoints.up('xs')]: {
            width: `100px`,
        },
        [theme.breakpoints.up('sm')]: {
            width: `90%`,
        },
        [theme.breakpoints.up('md')]: {
            width: `90%`,
        },
        [theme.breakpoints.up('lg')]: {
            width: `90%`,
        },
        [theme.breakpoints.up('xl')]: {
            width: `90%`,
        },
    },
    logotwo: {
        [theme.breakpoints.up('xs')]: {
            width: `70px`,
        },
        [theme.breakpoints.up('sm')]: {
            width: `80%`,
        },
        [theme.breakpoints.up('md')]: {
            width: `80%`,
        },
        [theme.breakpoints.up('lg')]: {
            width: `80%`,
        },
        [theme.breakpoints.up('xl')]: {
            width: `80%`,
        },
    },
    icon: {
        [theme.breakpoints.up('xs')]: {
            minWidth: '56px'
        },
        [theme.breakpoints.up('sm')]: {
            width: `40%`,
        },
        [theme.breakpoints.up('md')]: {
            width: `24%`,
        },
        [theme.breakpoints.up('lg')]: {
            width: `24%`,
        },
        [theme.breakpoints.up('xl')]: {
            width: `24%`,
        },
    },
    listItems: {
        [theme.breakpoints.up('xs')]: {
            color: 'white',
            fontSize: '70%'
        },
        [theme.breakpoints.up('sm')]: {
            color: 'white',
            fontSize: '100%'
        },
        [theme.breakpoints.up('md')]: {
            color: 'white',
            fontSize: '100%'
        },
        [theme.breakpoints.up('lg')]: {
            color: 'white',
            fontSize: '100%'
        },
        [theme.breakpoints.up('xl')]: {
            color: 'white',
            fontSize: '100%'
        },
    },
    imgLogo: {height: '40%'},
    styleaccordion : {
        borderLeft: '3px solid rgba(255, 198, 0)',
        // backgroundColor : "#5A5759",
        color : "black",
        minWidth : "100%",
        width: `100%`,
    },
    colorbutton : {
        backgroundColor : "rgb(101,174,46);",
        color : "white",
        "&:hover": {
            backgroundColor : "rgb(101,174,46);",
            color : "white",
        }
    }
}));


const BeneficiaryFormDialog = ( {  onCloseBeneficiaryForm, openBeneficiaryForm, pristine, onAcceptClick, findAccountUser,
    beneficiaryFormData, beneficiaryFormDataExternal, clearForm, setEntity, setType, setDocument,  setInstitution, accounts, AddBeneficiaryCore, getSelectAccount, entities,
    institutions, userPermissions}) => {
    const [title, setTitle] = useState('Seleccione Cuenta del beneficiario');
    const [expanded, setExpanded] = useState(true);
    const [selected, setSelected] = useState(false);
    const [typeFind, setTypeFind] = useState('cedule')
    const classes = useStyles();

    const handleSubmit = (values) => {
        onAcceptClick(values)
    }
    const handleSelectAccount = (value) => {
        const { Codigo } = value
        setTitle(`${Codigo} - ${nameInternal}`)
        getSelectAccount(value)
        setExpanded(false)
        setSelected(true)
    }
    //functions
    const findAccountExist = (data) => {
        try {
            //console.log("Busca cedula",data)
            const { code } = data
            setTitle('Seleccione Cuenta del beneficiario')
            findAccountUser(code, typeFind )
            setSelected(false)
        } catch (error) {
            //console.log(error)
        }
        
    }
    const {name: nameInternal } = beneficiaryFormData
    const { cedule, name, beneficiary, number, entity, email, document, institution } = beneficiaryFormDataExternal
    console.log(userPermissions);
    
    
    let beneficiario = 'INTERNO'
    !beneficiary && (beneficiario = 'INTERNO')
    return (
            <Dialog
                fullScreen
                open={ openBeneficiaryForm }
                onClose={ onCloseBeneficiaryForm }
                fullWidth={true}
                maxWidth= 'xs'
                disableBackdropClick
                disableEscapeKeyDown
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{ 'Nuevo Beneficiario' }</DialogTitle>
                <AppBar >
                    <Toolbar style = {{ position: 'relative'}}>
                        <IconButton edge="start" color="inherit" onClick={onCloseBeneficiaryForm} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" style = {{ flex: 1}}>
                            {'Nuevo Beneficiario'}
                        </Typography>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                    </DialogContentText>
                        <br />
                         {checkPermissionUser(userPermissions, 1) &&
                        <Accordion >
                            <AccordionSummary
                                expandIcon={<ExpandMore style={{ color: "rgba(255, 198, 0)" }} className={classes.imgLogo} />}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                                className = {classes.styleaccordion}
                            >
                                <List>
                                    <ListItem key={1} >
                                        {/* <ListItemAvatar>
                                            <Avatar src = {process.env.PUBLIC_URL + '/images/32.png'} variant="square" className={classes.imgLogo}/>
                                        </ListItemAvatar> */}
                                        <ListItemText primary={ <Typography> BENEFICIARIOS INTERNOS </Typography> }  />
                                    </ListItem>
                                </List>
                            
                            </AccordionSummary>
                            <AccordionDetails>
                                
                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={12} sm = {12}>
                                    <br/>
                                        <BeneficiaryFindAccount 
                                            classes = { classes }
                                            selectype = { (val) => setTypeFind(val.value) }
                                            onSubmit = { findAccountExist }
                                            
                                        />
                                        {
                                            (accounts.length > 0) &&
                                            <SimpleExpansionPanel
                                                name = { title || 'seleccion' }
                                                expanded = {expanded}
                                                handleChange = { () => expanded ? setExpanded(false) : setExpanded(true) } >
                                                <SimpleList
                                                    dataList = {accounts}
                                                    name = {nameInternal}
                                                    selectAccount = { handleSelectAccount }
                                                />
                                            </SimpleExpansionPanel>
                                        }
                                        <br></br>
                                        <br></br>
                                        <Grid container  spacing={2}>
                                            <Grid item xs={6} >
                                                <Button
                                                    variant="contained"
                                                    // className = {classes.colorbutton}
                                                    fullWidth
                                                    color={'primary'}
                                                    disabled = {!selected}
                                                    onClick={() => AddBeneficiaryCore()}
                                                >
                                                    Aceptar
                                                </Button>
                                            </Grid>
                                            <Grid item xs={6} >
                                                <Button
                                                    fullWidth
                                                    style={{
                                                        fontSize: '0.6rem',
                                                        color: '#1a1919',
                                                        borderLeft: '3px solid rgba(255, 198, 0)',
                                                        backgroundColor: "white",
                                                        borderRadius: '0px',
                                                        fontFamily: 'Ubuntu',
                                                        fontWeight: 'bold'
                                                    }}
                                                    variant="contained"
                                                    // className = {classes.colorbutton}
                                                    onClick={() => onCloseBeneficiaryForm()}>
                                                    Cancelar
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>}
                        <br />
                         {checkPermissionUser(userPermissions, 2) &&
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMore style={{ color: "rgba(255, 198, 0)" }} className={classes.imgLogo} />}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                                className = {classes.styleaccordion}
                            >
                                <List>
                                    <ListItem key={1} >
                                        {/* <ListItemAvatar>
                                            <Avatar src = {process.env.PUBLIC_URL + '/images/33.png'} variant="square" className={classes.imgLogo}/>
                                        </ListItemAvatar> */}
                                        <ListItemText primary={ <Typography> BENEFICIARIOS OTRAS INSTITUCIONES </Typography> }  />
                                    </ListItem>
                                </List>
                            
                            </AccordionSummary>
                            <AccordionDetails>
                                <BeneficiaryForm
                                    cedule = { cedule }
                                    email = {email} 
                                    name = { name }
                                    number = {number}
                                    entity = {entity}
                                    document = {document}
                                    institution = {institution}
                                    institutions = { institutions }
                                    setEntity = {setEntity}
                                    setType = { setType }
                                    setDocument = {setDocument}
                                    setInstitution = { setInstitution }
                                    beneficiary = { beneficiario }
                                    clearForm = { clearForm }
                                    entities = { entities }
                                    classes = { classes }
                                    onSubmit = { handleSubmit }
                                    cancelPrompt = { onCloseBeneficiaryForm }
                                    // findAccount = { findAccountExist }
                                />
                            </AccordionDetails>
                        </Accordion>}
                  </DialogContent>
                <DialogActions>
                </DialogActions>
        </Dialog>
    );
};

BeneficiaryFormDialog.propTypes = {
    onCloseBeneficiaryForm: PropTypes.func.isRequired,
    findAccountUser: PropTypes.func.isRequired,
    openBeneficiaryForm: PropTypes.bool.isRequired,
    onAcceptClick: PropTypes.func.isRequired,
}

export default BeneficiaryFormDialog;